import axios from "axios";
import {axiosAuthHeader} from "config/axiosConfig";
import api from "../api";

export const getDocumentListDeposit = async (offset:number,limit:number) => {
    return getDocumentListByType("DEPOSIT",offset,limit);
}

export const getDocumentListWithdrawal = async (offset:number,limit:number) => {
    return getDocumentListByType("WITHDRAWAL",offset,limit);
}

export const getDocumentListChangeInvestments = async (offset:number,limit:number) => {
    return getDocumentListByType("CHANGE_INVESTMENT",offset,limit);
}
export const getDocumentListIndexUpdate = async (offset:number,limit:number) => {
    return getDocumentListByType("PERSONAL_INDEX_UPDATE",offset,limit);
}

export const getDocumentListTaxes = async (offset:number,limit:number) => {
    return getDocumentListByType("TAX_COLLECT",offset,limit);
}
export const getDocumentListByType = async (type:string,offset:number,limit:number) => {
    return api.get(`/document-list?offset=${offset}&limit=${limit}&type=${type}`,axiosAuthHeader())
        .then(res => {
            return res;
        })
        .catch(e =>{
            return e;
        })
}

export const initializeUserPortfolio = async (userPortfolio: any) => {
    return api.post(`/initial-portfolio`, userPortfolio, axiosAuthHeader())
        .then(res => {
            return res;
        })
        .catch(e =>{
            return e;
        })
}

export const getCoinsList = async () => {
    return api.get(`/coins`,axiosAuthHeader())
        .then(res => {
            return res;
        })
        .catch(e =>{
            return e;
        })
}

export const getActualPortfolio = async () => {
    return api.get(`/actual-portfolio`,axiosAuthHeader())
        .then(res => {
            return res;
        })
        .catch(e =>{
            return e;
        })
}
